import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import ReactPaginate from "react-paginate";
// import "./Paginating.css"; // Ensure styles are imported if necessary
import { paginatingCards } from "../../../api/apiServices";
import { Link } from "react-router-dom";

// Fetch posts with pagination
const fetchPosts = async ({ queryKey }) => {
	console.log(queryKey);
	const [page] = queryKey; // Destructure to get the current page from queryKey
	const postsPerPage = 10;
	const res = await fetch(
		`http://localhost:3030/cards/fetch_cards?page=${page}&limit=${postsPerPage}`
	);
	// const totalPosts = res.headers.get("X-Total-Count"); // Get total number of posts

	const data = await res.json();

	const totalPosts = data?.total_records;
	// console.log(totalPosts)
	return { data, totalPosts };
};

export const PaginatingCard = () => {
    useEffect(() => {
		// 👇️ scroll to top on page load
		window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	}, []);

	const [currentPage, setCurrentPage] = useState(1);
	const postsPerPage = 20;

	// Fetch posts with React Query v5 signature
	//   const { data, isLoading, isError } = useQuery({
	//     queryKey: [currentPage],
	//     queryFn: fetchPosts,
	//     placeholderData: (prevData) => prevData ?? { data: [], totalPosts: 0 }, // Use placeholderData to keep previous data // Keep previous data while fetching new data
	//   });

	const {
		data: cards,
		isLoading,
		isError,
		error,
	} = useQuery(
		["cards", currentPage],
		() => paginatingCards(currentPage),
		{
			keepPreviousData: true,
		},
		{}
	);

	if (isLoading) return <p>Loading...</p>;
	if (isError) return <p>Error fetching posts</p>;

	const pageCount = Math.ceil(cards.total_records / postsPerPage);
	//   const pageCount = Math.ceil(data.totalPosts / postsPerPage);

	// Handle page click
	const handlePageClick = (event) => {
		setCurrentPage(event.selected + 1); // Fix: Add 1 to convert from 0-based index to 1-based
	};

	let content;
	if (isLoading) {
		content = <p>Loading Membership Cards...</p>;
	} else if (isError) {
		content = <p>{error.message}</p>;
	} else {
		content = (
			<div className="table-responsive lg table-wrapper">
				<table className="table table-bordered table-hover table-striped">
					<thead>
						<tr>
							<th scope="col" style={{ textAlign: "center" }}>
								#
							</th>
							<th scope="col">PF Number</th>
							<th scope="col">Name</th>
							<th scope="col">Region</th>
							<th scope="col">Printed</th>
							<th scope="col">issued</th>
							<th scope="col">Date issued</th>
							<th scope="col" style={{ textAlign: "center" }}>
								Action
							</th>
						</tr>
					</thead>
					<tbody>
						{cards?.data?.data.map((card, index) => (
							<tr key={card.id}>
								<td style={{ textAlign: "center" }}>
									{postsPerPage * (currentPage - 1) +
										index +
										1}
								</td>
								<td>{card.pf_number}</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{card.first_name}&nbsp;{card.middle_name}
									&nbsp;{card.last_name}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{card.region}
								</td>
								<td style={{ textAlign: "center" }}>
									{card.received_from_printer ? "YES" : "NO"}
								</td>
								<td style={{ textAlign: "center" }}>
									{card.issued_status ? "YES" : "NO"}
								</td>
								<td style={{ textAlign: "center" }}>
									{card.date_issued}
								</td>
								<td
									style={{
										textAlign: "center",
										whiteSpace: "nowrap",
									}}
								>
									<div style={{ display: "inline-block" }}>
										<Link
											to={`/view_card/${card.id}`}
											className="small"
										>
											<i className="fa fa-eye"></i> view
										</Link>
									</div>
									&nbsp; &nbsp;
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}

	return (
		<>
			<section className="content-header">
				<h1>Card Management - Global Cards</h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title"></h4>
									</div>
								</div>
							</div>
							<div className="panel-body">{content}</div>
							<div className="panel-footer">
								<ReactPaginate
									previousLabel={"Previous"}
									nextLabel={"Next"}
									breakLabel={"..."}
									breakClassName={"break-me"}
									pageCount={pageCount}
									marginPagesDisplayed={2} // How many pages to show at the beginning and end
									pageRangeDisplayed={3} // How many pages to show around the current page
									onPageChange={handlePageClick}
									containerClassName={"pagination"}
									activeClassName={"active"}
								/>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
